import { render } from "./SetCurrentLocalizationModal.vue?vue&type=template&id=c997d77a"
import script from "./SetCurrentLocalizationModal.vue?vue&type=script&lang=js"
export * from "./SetCurrentLocalizationModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__